import { Navigate, Route } from 'react-router-dom';
import { createApp } from '@backstage/app-defaults';
import { AppRouter, FlatRoutes } from '@backstage/core-app-api';
import { googleAuthApiRef } from '@backstage/core-plugin-api';
import { AlertDisplay, OAuthRequestDialog, SignInPage } from '@backstage/core-components';
import { ApiExplorerPage } from '@backstage/plugin-api-docs';
import { CatalogEntityPage, CatalogIndexPage, catalogPlugin } from '@backstage/plugin-catalog';
import { TechDocsIndexPage, TechDocsReaderPage, techdocsPlugin } from '@backstage/plugin-techdocs';
import { UserSettingsPage } from '@backstage/plugin-user-settings';
import { Root } from './components/Root';
import { entityPage } from './components/EntityPage';
import { ClusterPage } from './components/ClusterPage';
import { apis } from './apis';

const app = createApp({
  apis,
  bindRoutes({ bind }) {
    bind(catalogPlugin.externalRoutes, { viewTechDoc: techdocsPlugin.routes.docRoot });
  },
  components: {
    SignInPage: props => <SignInPage {...props} auto providers={[{
      id: 'google-auth-provider', title: 'Google Workspace',
      message: 'Sign in with your Orbiri Workspace account', apiRef: googleAuthApiRef,
    }]} />,
  },
});

export default app.createRoot(
  <>
    <AlertDisplay />
    <OAuthRequestDialog />
    <AppRouter>
      <Root>
        <FlatRoutes>
          <Route path="/" element={<Navigate to="/cluster" replace />} />
          <Route path="/cluster" element={<ClusterPage />} />
          <Route path="/catalog" element={<CatalogIndexPage initiallySelectedFilter="all" />} />
          <Route path="/catalog/:namespace/:kind/:name" element={<CatalogEntityPage />}>{entityPage}</Route>
          <Route path="/api-docs" element={<ApiExplorerPage />} />
          <Route path="/docs" element={<TechDocsIndexPage />} />
          <Route path="/docs/:namespace/:kind/:name/*" element={<TechDocsReaderPage />} />
          <Route path="/settings" element={<UserSettingsPage />} />
        </FlatRoutes>
      </Root>
    </AppRouter>
  </>,
);
